export { default } from './footer'
